import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorCustomizerDirective } from './paginator-customizer.directive';

@NgModule({
  declarations: [
    PaginatorCustomizerDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    PaginatorCustomizerDirective
  ]
})
export class AgGridCustomDirectivesModule { }
